<template>
    <div class="w-full grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 items-end">
      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Room Type")}}</label>
        <select :value="r.type" @change="updateField('type', $event.target.value)" id="roomTypes" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3">
          <option :selected="r.type == 'SGL'" value="SGL">{{tr("Single")}}</option>
          <option :selected="r.type == 'DBL'" value="DBL">{{tr("Double")}}</option>
          <option :selected="r.type == 'TPL'" value="TPL">{{tr("Triple")}}</option>
          <option :selected="r.type == 'OTHERS'" value="OTHERS">{{tr("Others")}}</option>
        </select>
      </div>
      <div class="mb-5">
        <label  class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Guest")}}</label>
        <input :value="r.names" @input="updateField('names', $event.target.value)" type="text" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent  outline-none block w-full p-3 " :placeholder="tr('Please, write the names of the people in the room.')" />
      </div>
    </div>
</template>

<script>
export default {
  name: 'BookingFromRoom',
  data() {
    return {
      r: {}
    }
  },
  mounted () {
    this.r = Object.assign({}, this.room);
  },
  props: {
    room: Object
  },
  methods: {
    update () {
      this.$emit('update', this.r)
    },
    updateField (key, value) {
      this.r[key] = value;
      this.update();
    },
    tr (key) {
      return this.$root.tr(key);
    }
  }
}
</script>
